function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import styled, { css } from 'styled-components';
import PropTypes from 'prop-types';
import { width, height } from 'styled-system';
import { applyVariations, getPaletteColor } from '../utils';
var variations = {
  parallax: css(["background-attachment:fixed;"]),
  "static": css(["background-attachment:scroll;"])
};

var image = function image(props) {
  return props.image ? {
    backgroundImage: "url(".concat(props.image, ")")
  } : null;
};

var BackgroundImage = styled.div.withConfig({
  displayName: "BackgroundImage",
  componentId: "alh3et-0"
})(["background-position:center;background-size:cover;background-repeat:no-repeat;background-color:", ";", " ", " ", " ", ";"], getPaletteColor('border.light'), applyVariations('BackgroundImage', variations), image, height, width);
BackgroundImage.defaultProps = {
  variation: 'static'
};
BackgroundImage.propTypes = _objectSpread(_objectSpread(_objectSpread({}, height.propTypes), width.propTypes), {}, {
  /** background-image url */
  image: PropTypes.string,
  variation: PropTypes.oneOf(Object.keys(variations))
});
BackgroundImage.displayName = 'BackgroundImage';
export default BackgroundImage;